/** Well above a batched bulk send, well under the 60s ALB idle timeout. */
export const SEND_TIMEOUT_MS = 30_000;
